module.exports = __webpack_public_path__ + "img/idea.27595ec0.svg";